<div class="auth-footer" style="background-image: url('assets/images/Footer-Ghost-Logo.png');">
    <div class="container footer-mob">
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <img class="footer-logo"  src="assets/images/logo.svg">
                </div>
                <div class="row">
                    <p class="send-money-text">Send money across borders,<br> the easy way.</p>
                </div>
                <div class="row">
                <ul>
                    <li class="pt-3">
                        <a class="primary-text font-weight-bold" href="#">Company</a>
                    </li>
                    <li class="pt-3">
                        <a class="secondary-text" href="#">About</a>
                    </li>
                    <li class="pt-3">
                        <a class="secondary-text" href="https://blog.n2xpress.com/">Blog</a>
                    </li>
                </ul>
            </div>
            </div>
            <div class="col-md-6">
                <button [routerLink]="['/signin']" class="btn footer-register px-5 text-light">Sign in</button>
            </div>
        </div>
    </div>
</div>